export interface LicenseUsageBudget {
  readonly amount: number;
  readonly is_cents: boolean;
  readonly unit_display_name: string;
}

export class AsmLicenseUsageTools {
  private static readonly locale = 'en-US';

  public static formatBudget(budget: LicenseUsageBudget): string {
    if (typeof budget.amount !== 'number' || !Number.isFinite(budget.amount)) {
      return '—';
    }
    const amount = budget.is_cents ? budget.amount / 100 : budget.amount;
    const formatter = new Intl.NumberFormat(
      AsmLicenseUsageTools.locale,
      budget.is_cents ? { minimumFractionDigits: 2, maximumFractionDigits: 2 } : {},
    );
    const formatted = formatter.format(amount);
    return budget.unit_display_name ? `${formatted} ${budget.unit_display_name}` : formatted;
  }
}
